import { render, staticRenderFns } from "./PermissionSetting.vue?vue&type=template&id=1fe1fc08&scoped=true&"
import script from "./PermissionSetting.vue?vue&type=script&lang=ts&"
export * from "./PermissionSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe1fc08",
  null
  
)

export default component.exports